import { render } from "./Strength.vue?vue&type=template&id=2d0524dc&scoped=true"
import script from "./Strength.vue?vue&type=script&lang=js"
export * from "./Strength.vue?vue&type=script&lang=js"

import "./Strength.vue?vue&type=style&index=0&id=2d0524dc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0524dc"]])

export default __exports__